import React from 'react'
import Modal from './Modal'

export default function ModalAlert({ alert, cancelText, acceptText, onSelect, onClose }) {
  return (
    <Modal
      visible={ true }
      closeModal={ onClose }
      mode='small centered'
      action={ onSelect }
      actionText={ acceptText || Website.translations.confirm }
      cancelAction={ onClose }
      cancelActionText={ cancelText || Website.translations.cancel }
    >
      <div className='modal-alert items-center flex-box flex-column content-space-around' style={{ height: '100%' }}>
        <div className='flex-box items-center content-center' style={{ fontSize: 15, height: '100%', textAlign: 'center' }}>
          { alert }
        </div>
      </div>
    </Modal>
  )
}
